module.exports = ReactDOM;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactDOM","var":"ReactDOM","commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom"}
 ** module id = 47
 ** module chunks = 0
 **/